import { render, staticRenderFns } from "./AdmissionInfo.vue?vue&type=template&id=24ca58a2"
import script from "./AdmissionInfo.vue?vue&type=script&lang=js"
export * from "./AdmissionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports